import React, { useEffect  , useState} from 'react'

import GenericGrid from '../../../components/grid/grid'
import { renderColumns } from '../../../utils/helper'


const dummyData = [
    {
        id:"1",
        nctNumber:"NCT XXXX01",
        title:"Title XXXX"
    },
    {
        id:"2",
        nctNumber:"NCT XXXX02",
        title:"Title XXXX"
    },
    {
        id:"3",
        nctNumber:"NCT XXXX03",
        title:"Title XXXX"
    },
    {
        id:"4",
        nctNumber:"NCT XXXX04",
        title:"Title XXXX"
    },
    {
        id:"5",
        nctNumber:"NCT XXXX05",
        title:"Title XXXX"
    },
    {
        id:"6",
        nctNumber:"NCT XXXX06",
        title:"Title XXXX"
    },
    {
        id:"7",
        nctNumber:"NCT XXXX07",
        title:"Title XXXX"
    },
    {
        id:"8",
        nctNumber:"NCT XXXX08",
        title:"Title XXXX"
    },
    {
        id:"9",
        nctNumber:"NCT XXXX09",
        title:"Title XXXX"
    },
    {
        id:"10",
        nctNumber:"NCT XXXX10",
        title:"Title XXXX"
    },
    {
        id:"11",
        nctNumber:"NCT XXXX11",
        title:"Title XXXX"
    },
    {
        id:"12",
        nctNumber:"NCT XXXX12",
        title:"Title XXXX"
    },
    {
        id:"13",
        nctNumber:"NCT XXXX12",
        title:"Title XXXX"
    },
    {
        id:"14",
        nctNumber:"NCT XXXX12",
        title:"Title XXXX"
    },
]

const localKey = "shot_example_row"

const LeftContent = ( { selectedGridRow , setSelectedGridRow } ) => {
    const [dataState, setDataState] = useState({
      skip: 0,
      take: 100,
      sort: [],
      filter: null
    });
    
    const [ data , setData ] = useState( [] )
        
    const handleSelectionChange = (event) => {
      const newData = data.map(item => ({
        ...item,
        selected: item.id === event.dataItem.id
      }));
    
      const selectedItem = newData.find( item => item.selected )
    
      setData(newData);
      
      setSelectedGridRow( selectedItem ? selectedItem : {}  )
    
      localStorage.setItem( "shot_example_row" , JSON.stringify( selectedItem ? selectedItem : {} ) )
    
    };
    
    const handleDataStateChange = (e) => {
      setDataState(e.dataState);
    }
    
    const columns = [
      {
        title: "Studies", 
        children: [
          { field: "nctNumber" ,    headerCell: () => <th style={{display:"none"}}></th> },
          { field: "title" ,    headerCell: () => <th style={{display:"none"}}></th>},
      
        ]
      }
    ];

    //set the data
    useEffect(()=>{
       setData( dummyData )
    },[])

  useEffect(()=>{
   const storedgridRow = JSON.parse( localStorage.getItem( "studies_Sel_row" ) )
   if( storedgridRow ) setSelectedGridRow( storedgridRow )
  },[])

  return (
    <>
        <GenericGrid
               data={data}
               columns={renderColumns(columns)}
               dataState={dataState}
               onDataStateChange={handleDataStateChange}
               pageable={false}
               sortable={false}
               filterable={false}
               style={{ height:"100vh" }}
               dataItemKey = { "id" }
              selectable={{
                        enabled: true,
                        mode: "single",
                        drag: false,
                        cell: false}}
               onSelectionChange={handleSelectionChange}
               selectedRow = { selectedGridRow }
               storageField = {localKey}
               />
    </>
  )
}

export default LeftContent